import styled from "styled-components";
import { Modal } from "components/Modal";

export const ScheduleModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 600px;
    height: auto;
  }

  .modal-content {
    padding: 0px;
    border-radius: 16px;
  }

  .modal-body {
    padding: 0px;
    margin-top: 0px;
  }
`;

export const ScheduleHeader = styled.div`
  padding: 16px 32px 12px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;

  h2 {
    font-size: 16px;
    font-family: "Geist", sans-serif;
    text-align: start;
    color: #181d27;
    font-weight: 500;
    margin-bottom: 0px;
  }
`;

export const ScheduleBody = styled.div`
  padding: 20px 32px 24px;
  border-top: 1px solid #e9eaeb;
  border-bottom: 1px solid #e9eaeb;

  .description {
    font-size: 14px;
    font-family: "Geist", sans-serif;
    font-weight: 400;
    color: #535862;
    line-height: 20px;
    margin-top: 2px;
    margin-bottom: 0px;
  }

  .trade-days {
    margin-top: 20px;
  }
`;

export const ScheduleFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin: 24px;
`;
